module.exports = __webpack_public_path__ + "public/images/learn-spanish.1850cebf88e9a4878a08c364f57ecda1.jpg";